



export class HisDto {
  檢查日期: string = "";
  公司編號: string = "";
  ihosp :string = "";

  isn: string = "";
  身份證號: string = "";

  /** M/F */
  性別: string = "";

  姓名: string = "";
  生日: string = "";
  受雇日期: string = "";

  問卷基礎: HisBasicDto[] = [];
  問卷明細: HisRowDto[] = [];
  問卷申報: GovRowDto[] = [];
  問卷UI基礎?: HisUiDto;
}

export class HisBasicDto {
  作業編號?: string;

  曾經從事?: string;
  曾經從事開始日?: string;
  曾經從事結束日?: string;

  目前從事?: string;
  目前從事開始日?: string;
  目前從事結束日?: string;

  一個月平均工時?: string;
  六個月平均工時?: string;
  平均睡眠時間?: string;

  本作業平均工時?: string;

  /* N/Y */
  是否輪班?: string;
  輪班幾班制?: string;
  輪班幾班制_其他?: string;

  /** "10301(民國年月)" */
  目前從事開始月?: string;
  特殊危害健康作業編號?: string;

  一個月夜間工作日數?: string;
  六個月夜間工作日數?: string;
  一年內夜間工時?: string;
  一年內夜間工作日數?: string;

  工作班別?: string;

  /** o:其他 */
  其它輪班班別?: string;

  上班時間?: string;
  下班時間?: string;

  工作日平均睡眠時間?: string;
  休息日平均睡眠時間?: string;

}

export class HisRowDto {
  作業編號?: string;
  類別?: string;
  項目?: string;
  結果?: string;
  備註?: string;
}

export class GovRowDto {
  作業編號?: string;
  問題類別?: string;
  問題編號?: string;
  答題內容?: string;
  答題內容_1?: string;
  答題內容_2?: string;
  答題內容_3?: string;
  答題內容_4?: string;
}
export class HisTestDto {
  作業編號?: string;
  個人資料?: string;
  作業經歷?: string;
  既往病史?: string;
  生活習慣?: string;
  自覺症狀?: string;
  糖尿病?: string;
  吸菸?: string;
  曾經從事?: string;
  曾經從事起始年月日?: string;
  曾經從事截止年月日?: string;
  目前從事?: string;
  目前從事起始年月日?: string;
  目前從事截止年月日?: string;
}
export class HisUiDto {
  曾經從事?: string = '';
  曾經從事開始日?: string = '';
  曾經從事結束日?: string = '';
  目前從事?: string = '';
  目前從事開始日?: string = '';
  目前從事結束日?: string = '';
  既往病歷1?: string = '';
  既往病歷2?: string = '';
  作業經歷?: string = '';
  自覺症狀?: string = '';
  既往病歷?: string = '';
  ICD10?: string = '';
} 
